// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df87943e","239":"f5cd6dec","453":"269ad53c","732":"71c37547"}[chunkId] + ".chunk.js";
};